import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

const getSpaceDefaultState = () => {
  return {
    latitude: 24.725067,
    longitude: 121.757453,
    rockettime: 0,
  };
};

const formatDate = (date, sp) => {
  let enddate = date;
  let spStr = sp || ".";
  let dateYear = new Date(enddate).getFullYear();
  let dateMonth = (new Date(enddate).getMonth() + 1)
    .toString()
    .padStart(2, "0");
  let dateDate = new Date(enddate).getDate().toString().padStart(2, "0");
  return `${dateYear}${spStr}${dateMonth}${spStr}${dateDate}`;
};

const moduleSpace = {
  namespaced: true,
  state: getSpaceDefaultState(),
  actions: {
    updateRockettime(context, payload) {
      context.commit("ROCKETTIME_UPDATE", payload);
    },
    updateGeo(context, payload) {
      context.commit("GEO_UPDATE", payload);
    },
    resetState(context) {
      context.commit("STATE_RESET");
    },
  },
  mutations: {
    ROCKETTIME_UPDATE(state, payload) {
      state.rockettime = payload.rockettime;
    },
    GEO_UPDATE(state, payload) {
      // let companyLatCenter = 24.671553;
      // let companyLonCenter = 121.777835;
      // let spaceLatCenter = 24.725067;
      // let spaceLonCenter = 121.757453;
      // let distnLat = payload.latitude - companyLatCenter;
      // let distnLon = payload.longitude - companyLonCenter;

      // state.latitude = distnLat + spaceLatCenter;
      // state.longitude = distnLon + spaceLonCenter;

      state.latitude = payload.latitude;
      state.longitude = payload.longitude;
    },
    STATE_RESET(state) {
      let today = formatDate(new Date(), "-");
      if (Date.now() >= new Date(`${today} ${window.g.C_START}`).getTime()) {
        let rockettime = state.rockettime;
        Object.assign(state, getSpaceDefaultState());
        state.rockettime = rockettime;
      } else {
        Object.assign(state, getSpaceDefaultState());
      }
    },
  },
};

export default new Vuex.Store({
  modules: {
    space: moduleSpace,
  },
  plugins: [vuexLocal.plugin],
});
